import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface IScrollToTopProps {
  dependency?: unknown;
}

const ScrollToTop: React.FC<IScrollToTopProps> = ({ dependency }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      const contentWrapper = document.getElementById('contentWrapper');
      if (contentWrapper) {
        contentWrapper.scrollTop = 0;
      }
    };

    scrollToTop();
    const timer = setTimeout(scrollToTop, 100);
    return () => clearTimeout(timer);
  }, [pathname, dependency]);

  return null;
};

export default ScrollToTop;
